import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, { useRef } from "react";
import { Payment } from "../../types/types";
import { ColDef } from "ag-grid-community";
import "./aggridCustom.css";
import { BLUE, GREEN, ORANGE, RED } from "../../styles/mui-theme";
import { formatCOP } from "../../utils/format";

const TABLE_MIN_HEIGHT = "700px";

interface Props {
  payments: Payment[];
  isFetching: boolean;
}

const DailyBudgetInvoiceItemsTable: React.FC<Props> = ({ payments, isFetching }) => {
  const gridRef = useRef<AgGridReact<Payment> | null>(null);

  const rowData = isFetching ? undefined : payments;

  const columnDefs: ColDef[] = [
    { headerName: "ID", field: "id", filter: true, width: 80 },
    { headerName: "Fecha", field: "date", width: 150, filter: "agDateColumnFilter" },
    { headerName: "Número", field: "number", filter: true, width: 120 },
    {
      headerName: "Monto",
      field: "amount",
      width: 130,
      valueFormatter: (params) => formatCOP(params.value),
    },
    {
      headerName: "Tipo",
      field: "type",
      filter: true,
      width: 100,
      valueFormatter: (params) => (params.value === "in" ? "Entrada" : "Salida"),
      cellStyle: (params) => {
        if (params.value === "in") {
          return { color: GREEN, fontWeight: "bold" };
        } else {
          return { color: RED, fontWeight: "bold" };
        }
      },
    },
    {
      headerName: "Método de Pago",
      field: "paymentMethod",
      width: 150,
      valueFormatter: (params) => (params.value === "cash" ? "Efectivo" : "Banco"),
      cellStyle: (params) => {
        if (params.value === "cash") {
          return { color: BLUE, fontWeight: "bold" };
        } else {
          return { color: ORANGE, fontWeight: "bold" };
        }
      },
    },
    {
      headerName: "Estado",
      field: "status",
      filter: true,
      width: 100,
      valueFormatter: (params) => (params.value === "open" ? "Abierto" : "Cerrado"),
    },
    { headerName: "Cliente", field: "client.name", filter: true, width: 200 },
    { headerName: "Teléfono del Cliente", field: "client.phone", hide: true, width: 150 },
    {
      headerName: "Identificación del Cliente",
      field: "client.identification",
      hide: true,
      width: 150,
    },
    { headerName: "Banco/Caja", field: "bankAccount.name", filter: true, width: 200 },
    { headerName: "Factura ID", field: "invoices[0].id", hide: true },
    { headerName: "Factura Número", field: "invoices[0].number", hide: true },
    { headerName: "Factura Monto", field: "invoices[0].amount", hide: true },
    { headerName: "Categoría", field: "categories[0].name", filter: true, hide: true },
    { headerName: "Observaciones", field: "observations", width: 200, hide: true },
  ];

  return (
    <div className={"ag-theme-quartz"} style={{ width: "100%", minHeight: TABLE_MIN_HEIGHT }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        overlayLoadingTemplate={"<span>Cargando transacciones...</span>"}
        overlayNoRowsTemplate={"<span>No hay transacciones para esta fecha.</span>"}
        rowSelection={"single"}
        ref={gridRef}
      />
    </div>
  );
};

export default DailyBudgetInvoiceItemsTable;
